import { useSelector } from 'react-redux';

import { getBookmarkList, getCheckedBookmarksList } from './index';

export const useBookmarkList = () => useSelector(getBookmarkList);
export const useCheckedBookmarkList = () =>
    useSelector(getCheckedBookmarksList);
